import React from 'react'
import { IconButton } from '@mui/material';
import {
  WhatsApp as WhatsAppIcon
} from '@mui/icons-material';

import { whatsappApi } from '@/main/api';
import { getTranslateByKey, isEmpty } from '@/main/services/utils';

import * as S from './styles';

interface IWhatsappLinkProps {
  phone: string;
  companyName: string;
  claimNumber: string;
  orderNumber: string;
  vehicleName: string;
  isWhatsapp?: boolean;
  insurerName?: string;
}
function WhatsappLink({
  claimNumber,
  companyName,
  orderNumber,
  phone,
  vehicleName,
  insurerName,
  isWhatsapp = false
}: IWhatsappLinkProps) {
  function renderMessage() {
    const messageClaimOrderNumber = !isEmpty(claimNumber) ? getTranslateByKey('information.messageWhatsappClaim').replace('{0}', claimNumber) : '';
    const messageInsurer = !isEmpty(insurerName) ? getTranslateByKey('information.messageWhatsappInsurer').replace('{0}', insurerName) : '';
    const messageFinal = getTranslateByKey('information.messageWhatsapp')
      .replace('{0}', companyName)
      .replace('{1}', messageClaimOrderNumber)
      .replace('{2}', orderNumber)
      .replace('{3}', vehicleName)
      .replace('{4}', messageInsurer);

    return messageFinal;
  }
  function handleClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    e.stopPropagation();
    const message = renderMessage();
    const formattedPhone = phone.replace(/\s/g, '');

    return whatsappApi.sendMessage(formattedPhone, message);
  }
  if (isEmpty(phone)) return <></>;
  return (
    <S.Container>
      <span>+{phone.trimStart()}</span>
      {isWhatsapp &&
        <IconButton
          title={getTranslateByKey('information.sendMessageWhatsapp')}
          onClick={handleClick}
        >
          <WhatsAppIcon
            fontSize='small'
            style={{ color: '#25D366' }}
          />
        </IconButton>
      }
    </S.Container>
  )
}

export default WhatsappLink